<nav class="navbar">
  <!-- Logo Section -->
  <div class="navbar-brand">
    <img ngSrc="assets/logo.png" alt="Atlas Logo" class="logo-image" width="119" height="40" priority />
    <div class="brand-text">
      <span class="brand-title">Oil Sample Custody Form Generator</span>
      <span class="brand-subtitle">OSC Form Generator</span>
    </div>
  </div>

  <div class="navbar__actions">
    <a
      class="help-button"
      href="assets/COCHelp%201.pdf"
      target="_blank"
      rel="noopener"
      aria-label="Open COC help guide in a new tab"
    >
      <svg class="help-button__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="12" cy="12" r="9" />
        <path d="M9.8 9a2.25 2.25 0 1 1 3.8 1.6c-.9.8-1.6 1.2-1.6 2.7M12 16.8v.1" />
      </svg>
      <span>Help</span>
    </a>

    <button
      type="button"
      class="theme-toggle"
      (click)="themeService.toggle()"
      [attr.aria-pressed]="themeService.isDark()"
      [attr.aria-label]="themeService.isDark() ? 'Switch to light theme' : 'Switch to dark theme'"
    >
      <span aria-hidden="true">{{ themeService.isDark() ? '☀️' : '🌙' }}</span>
    </button>

    @if (authService.displayName()) {
      <div class="user-menu">
        <button
          type="button"
          class="user-menu__trigger"
          (click)="toggleUserMenu()"
          aria-haspopup="true"
          [attr.aria-expanded]="isUserMenuOpen()"
          aria-controls="user-menu-panel"
        >
          <span class="user-menu__avatar" aria-hidden="true">{{ authService.initials() }}</span>
          <span class="user-menu__name">{{ authService.displayName() }}</span>
        </button>

        @if (isUserMenuOpen()) {
          <div class="user-menu__panel" id="user-menu-panel" role="menu">
            <button type="button" role="menuitem" class="user-menu__item" (click)="signOut()">
              Sign out
            </button>
          </div>
        }
      </div>
    }
  </div>
</nav>
